import { ApplicationDetailedLifecycle } from '../constants/detailedLifecyle';
import { ApplicationLifecycle } from '../constants/lifecycle';

const PIA_PLAN_F_LIFECYCLES: string[] = [
  ApplicationLifecycle.PIA,
  ApplicationLifecycle.PLAN_F,
];

// A finished PIA or Plan F case has lifecycle COMPLETED; only the detailed
// lifecycle says which flow it finished.
const COMPLETED_PIA_PLAN_F_DETAILED_LIFECYCLES: string[] = [
  ApplicationDetailedLifecycle.COMPLETED_PIA,
  ApplicationDetailedLifecycle.COMPLETED_PLAN_F,
];

/**
 * True while a case is in the PIA or Plan F lifecycle, including once either has
 * completed. Not the same as "the policy is activated", which is also true for
 * cases in other lifecycles.
 */
export const isPiaOrPlanFLifecycle = (
  lifecycle?: string | null,
  detailedLifecycle?: string | null,
): boolean =>
  PIA_PLAN_F_LIFECYCLES.includes(lifecycle ?? '') ||
  COMPLETED_PIA_PLAN_F_DETAILED_LIFECYCLES.includes(detailedLifecycle ?? '');
